import * as React from "react"

const Bag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path d="M12.67 12.67H3.33V6h9.34v6.67ZM8 3.33c1.24 0 2.27.86 2.57 2H5.43c.3-1.14 1.33-2 2.57-2Zm3.27 2a3.33 3.33 0 0 0-6.54 0H2.67v8h10.66v-8h-2.06Z" />
  </svg>
)

export default Bag
